import { observer } from 'mobx-react';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { findLink } from '../../../../../../LinkyLinky';
import GenericSortFilter from '../../../../../GenericSortFilter';
import InvitationsStore from '../../Store';
import ProgramFamiliesFilter from './ProgramFamiliesFilter';
import Search from './Search';

interface Props {
  store: InvitationsStore;
}

function Filters({ store }: Props) {
  switch (store.optionsStore.state.kind) {
    case 'ready':
      const { payload, links } = store.optionsStore.state.resource;
      return (
        <div className="flex items-end flex-row my-5 sm:flex-col sm:items-start">
          <Search store={store} />
          <div className="mr-4 w-1/4">
            <GenericSortFilter
              labelText={'Groups'}
              options={payload.userGroups}
              parameters={store.searchParameters}
              updatingParameters={store.updatingSearchParameters}
              sortFilterKey={'user_groups'}
            />
          </div>
          {findLink('options', links)
            .map((link) => <ProgramFamiliesFilter link={link} invitationsStore={store} />)
            .getOrElse(emptyFragment)}
          <div className="mr-4 w-1/4">
            <GenericSortFilter
              labelText={'Last Invitation Date'}
              options={payload.sendDate}
              parameters={store.searchParameters}
              updatingParameters={store.updatingSearchParameters}
              sortFilterKey={'send_date'}
            />
          </div>
          <div className="mr-4 w-1/4">
            <GenericSortFilter
              labelText={'Invitation Type'}
              options={payload.invitationType}
              parameters={store.searchParameters}
              updatingParameters={store.updatingSearchParameters}
              sortFilterKey={'invitation_type'}
            />
          </div>
          <div className="mr-4 w-1/4">
            <GenericSortFilter
              labelText={'Invitation Status'}
              options={payload.accessStatus}
              parameters={store.searchParameters}
              updatingParameters={store.updatingSearchParameters}
              sortFilterKey={'access_status'}
            />
          </div>
          <div className="mr-4 w-1/4">
            <GenericSortFilter
              labelText={'Collection Access'}
              options={payload.invitationStatus}
              parameters={store.searchParameters}
              updatingParameters={store.updatingSearchParameters}
              sortFilterKey={'invitation_status'}
            />
          </div>
        </div>
      );
    case 'error':
    case 'loading':
    case 'waiting':
      return (
        <div className="flex items-end w-full mb-8">
          <div className="h-8 w-[20%] bg-gray-300 rounded mr-[1.5%]"></div>
          <div className="w-[87%] flex">
            {[...Array(6)].map((_, index) => (
              <div key={index} className="w-full mr-2">
                <div className="h-3 w-[50%] bg-gray-300 rounded mb-2"></div>
                <div className="h-8 w-full bg-gray-300 rounded"></div>
              </div>
            ))}
          </div>
        </div>
      );
  }
}
export default observer(Filters);
